import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './InfoContainer.module.scss';

export interface IInfoContainer extends HTMLAttributes<HTMLDivElement> {}

const InfoContainer: FC<IInfoContainer> = (props) => {
  const { className, children } = props;
  const rootClassName = classNames(styles.root, className);
  return <div className={rootClassName}>{children}</div>;
};

export default InfoContainer;
